﻿/**
 * Image Block functionality
**/

(function ($) {
    $.fn.rlImageBlock = function () {
        $('.imageblock a').on('keydown', function (e) {
            const keycode = (e.keyCode ? e.keyCode : e.which);
            const url = $(this).attr('href');
            if (keycode == 32) {
                e.preventDefault();
                window.location = url;
            }
        });
    }
}(jQuery));